import React, { useState } from "react";
import {
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import "../../assets/css/icon.css";
import { assignmentTitleArray, languageTypeArray, personTypeArray } from "../../utils/seletctOptions";
import PopupError from "./PopupError";

const ALTRO = "Other";

const ModalAmlForm = ({
  onClose,
  confirm,
  errors = [],
  aml,
  setAml,
  mode = "create",
  errorPopup,
  setErrorPopup,
}) => {
  const isEdit = mode === "edit";

  const handleChange = (name, value) => {
    setAml((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <Grid
        container
        item
        xs={11}
        md={8}
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          width: { xs: "90%", sm: "80%" },
          maxHeight: "90vh",
          overflowY: "auto",
          borderRadius: "16px",
        }}
      >
        {/* HEADER */}
        <Grid
          item
          xs={12}
          sx={{
            height: 60,
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #c6c6c6",
            px: "15px",
            gap: "10px",
          }}
        >
          <div style={{ flexShrink: 0 }}>
            <div className="icon-create-AML-modal" />
          </div>
          <Typography
            className="color-blue-dark"
            sx={{ flex: 1, minWidth: 0, fontSize: 18, fontWeight: 600 }}
          >
            {isEdit ? "Modifica modello AML" : "Nuovo modello AML"}
          </Typography>
          <div style={{ flexShrink: 0 }}>
            <div onClick={onClose} className="icon-modal-close" />
          </div>
        </Grid>

        <Grid item xs={12} sx={{ padding: "20px" }}>
          <Grid container spacing={2}>
            {/* TYPE */}
            <Grid item xs={12} md={4}>
              <Typography className="color-blue-dark title-input">
                Tipologia cliente
              </Typography>
              <Select
                name="type"
                value={aml.type || ""}
                error={errors.includes("type")}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                displayEmpty
                fullWidth
                sx={{ mt: 0.5 }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {personTypeArray.map((item) => (
                  <MenuItem key={item.key} value={item.key}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {/* NAME */}
            {aml?.type && (
              <Grid item xs={12} md={4}>
                <Typography className="color-blue-dark title-input">
                  {aml.type === "PG"
                    ? "Denominazione sociale"
                    : "Nome e Cognome"}
                </Typography>
                <TextField
                  fullWidth
                  name="name"
                  placeholder="Inserisci"
                  value={aml.name || ""}
                  error={errors.includes("name")}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  sx={{ mt: 0.5 }}
                />
              </Grid>
            )}

            {/* EMAIL */}
            <Grid item xs={12} md={4}>
              <Typography className="color-blue-dark title-input">
                Email
              </Typography>
              <TextField
                fullWidth
                name="email"
                placeholder="Inserisci"
                value={aml.email || ""}
                error={errors.includes("email")}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                sx={{ mt: 0.5 }}
              />
            </Grid>

            {/* LANGUAGE */}
            <Grid item xs={12} md={4}>
              <Typography className="color-blue-dark title-input">
                Lingua modulo
              </Typography>
              <Select
                name="language"
                value={aml.language || ""}
                error={errors.includes("language")}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                displayEmpty
                fullWidth
                sx={{ mt: 0.5 }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {languageTypeArray.map((item) => (
                  <MenuItem key={item.key} value={item.key}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {/* RISK */}
            <Grid item xs={12} md={4}>
              <Typography className="color-blue-dark title-input">
                Rischio
              </Typography>
              <Select
                name="risk"
                value={aml.risk || ""}
                error={errors.includes("risk")}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                displayEmpty
                fullWidth
                sx={{ mt: 0.5 }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                <MenuItem value="medium">Medio</MenuItem>
                <MenuItem value="high">Alto</MenuItem>
              </Select>
            </Grid>

            {/* TITLE - commentato temporaneamente
            <Grid item xs={12} md={4}>
              <Typography className="color-blue-dark title-input">
                Natura e scopo della prestazione professionale
              </Typography>
              <Select
                name="title"
                value={aml.title || ""}
                error={errors.includes("title")}
                onChange={(e) => {
                  const val = e.target.value;
                  handleChange("title", val);
                  if (val !== ALTRO && aml.reason) handleChange("reason", "");
                }}
                displayEmpty
                fullWidth
                sx={{ mt: 0.5 }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {assignmentTitleArray.map((item) => (
                  <MenuItem key={item.key} value={item.key}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {aml.title === ALTRO && (
              <Grid item xs={12}>
                <Typography className="color-blue-dark title-input">
                  Descrizione incarico
                </Typography>
                <TextField
                  fullWidth
                  name="reason"
                  placeholder="Inserisci"
                  multiline
                  minRows={3}
                  maxRows={6}
                  value={aml.reason || ""}
                  error={errors.includes("reason")}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  sx={{ mt: 0.5 }}
                  InputProps={{ style: { color: "#1b2838", fontSize: "14px" } }}
                />
              </Grid>
            )}
            */}
          </Grid>

          {/* FOOTER */}
          <Grid
            container
            sx={{
              marginTop: "30px",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="button-bg-purple"
              variant="contained"
              onClick={confirm}
              sx={{
                // width: { xs: "140px", sm: "160px", md: "180px" },
                width: "140px",
                height: "40px",
                border: "none",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
              }}
            >
              {/* <Box className="icon-create-aml-button" />{" "} */}
              <Typography
                className="color-light"
                sx={{
                  textTransform: "none",
                  fontSize: { xs: "14px", sm: "16px", md: "18px" },
                  fontWeight: 500,
                  lineHeight: 1,
                }}
              >
                {isEdit ? "Modifica AML" : "Crea AML"}
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {errorPopup && (
        <div
          style={{
            width: "350px",
            position: "fixed",
            bottom: "-15px",
            left: "50%",
            backgroundColor: "#fff",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            padding: "12px 10px",
            borderRadius: "10px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
            fontSize: "14px",
          }}
        >
          <PopupError
            copyError="Uno o più campi obbligatori sono mancanti"
            closePopupError={() => setErrorPopup(false)}
          />
        </div>
      )}
    </>
  );
};

export default ModalAmlForm;
